/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { AppConfigModel } from '@models/app/app-config.model';
import { EditableParam } from '@models/quotation-calculate';

export const APP_CONFIG: AppConfigModel = {
  theme: {
    activeViews: [
      ['QUO_PREV_CMP', false],
      ['QUO_PREV_STD', true]
    ]
  },
  generic: {
    redirectUnauthorized: true
  },
  dev: {},
  obligations: {
    explicitConfirmation: true
  },
  quotation: {},
  security: {
    authHeaderName: 'qinetic_authorization',
    authStorageKeyName: 'requestToken',
    urlOutOfAuth: [
      'assets/i18n',
      'assets/demo',
      'qinetic-security/api/authenticate',
      'castlemock/mock/rest/project'
    ],
    authCodeRequired: true
  },
  position: {},
  wizard: {
    startPage: 'welcome'
  },
  survey: {},
  form: {},
  upload: {
    fileNameHeader: 'Content-Disposition',
    uploadSorting: [
      'DOC_IDE', // documenti d'identità
      'B03.1', // cartà identità
      'B03.2', // passaporto
      'B03.3', // patente
      'DI_AGG', // altri documenti d'identità
      'F22', // autocertificazione residenza
      'B05', // permesso di soggiorno
      'B04', // codice fiscale
      'DOC_RED', // documenti reddituali
      'B07', // busta paga
      'B94', // cedolino
      'DOC_RED_PENS', // Doc. reddituali pensionati
      'B09', // obis
      'B95', // obis
      'F06' // CUD
    ],
    checkSorting: [
      'B04', // codice fiscale
      'DOC_IDE', // documenti d'identità
      'B03.1', // cartà identità
      'B03.2', // passaporto
      'B03.3', // patente
      'DI_AGG', // altri documenti d'identità
      'F22', // autocertificazione residenza
      'B05', // permesso di soggiorno
      'DOC_RED', // documenti reddituali
      'B07', // busta paga
      'B94', // cedolino
      'DOC_RED_PENS', // Doc. reddituali pensionati
      'B09', // obis
      'B95', // obis
      'F06' // CUD
    ]
  },
  publisher: {},
  labels: {
    openLabelsUrl: './assets/i18n/open-labels.json'
  },
  recognition: {
    maxAttemps: 3
  },
  documentsRequest: {
    additionalRequestOperationCodes: ['WEB_RIC_DOC']
  },
  quotationCalculate: {
    preparationSections: [EditableParam.amount, EditableParam.duration],
    editableSections: [
      EditableParam.finality,
      EditableParam.amount,
      EditableParam.instalment,
      EditableParam.duration
    ]
  },
  digitalSignature: {},
  dashboard: {},
  analytics: {},
  atc: {}
};
